import { render, staticRenderFns } from "./returns-detailed.vue?vue&type=template&id=b09be8be&scoped=true&"
import script from "./returns-detailed.vue?vue&type=script&lang=js&"
export * from "./returns-detailed.vue?vue&type=script&lang=js&"
import style0 from "./returns-detailed.vue?vue&type=style&index=0&id=b09be8be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09be8be",
  null
  
)

export default component.exports